(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["archive-floating-buttons"] && !Shopify.designMode) return;
  try {
    
  (function initArchiveFloatingButtonsFooterOffset() {
    const floatingButtons = document.querySelectorAll('.archive-floating-buttons');
    if (floatingButtons.length === 0) return;

    const footerSelectors = [
      '[id*="shopify-section-group-footer-group"]',
      '[class*="footer-group"]',
      '#shopify-section-footer-group',
      '#footer-group',
      '.footer-utilities',
      'contentinfo',
      'footer',
    ];

    const observedResizeElements = new Set();
    const resizeObserver =
      'ResizeObserver' in window
        ? new ResizeObserver(() => {
            scheduleUpdate();
          })
        : null;

    function getFooterElements() {
      const uniqueElements = new Set();
      footerSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((element) => {
          uniqueElements.add(element);
        });
      });

      return Array.from(uniqueElements).filter((element) => {
        if (!(element instanceof HTMLElement)) return false;
        if (element.hidden) return false;

        const computedStyle = getComputedStyle(element);
        if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;

        const rect = element.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) return false;

        return true;
      });
    }

    function observeFooterElements() {
      if (!resizeObserver) return;

      resizeObserver.observe(document.documentElement);

      getFooterElements().forEach((element) => {
        if (observedResizeElements.has(element)) return;

        observedResizeElements.add(element);
        resizeObserver.observe(element);
      });
    }

    function getFooterTop() {
      const footerElements = getFooterElements();

      if (footerElements.length === 0) return Number.POSITIVE_INFINITY;

      let top = Number.POSITIVE_INFINITY;
      footerElements.forEach((element) => {
        top = Math.min(top, element.getBoundingClientRect().top);
      });

      return top;
    }

    function updateFloatingButtonsOffset() {
      const footerTop = getFooterTop();
      const viewportBottom = window.innerHeight;
      const overlap = Math.max(0, viewportBottom - footerTop);

      floatingButtons.forEach((floatingButton) => {
        floatingButton.style.setProperty('--archive-floating-footer-overlap', `${overlap}px`);
      });
    }

    let rafId = null;
    function scheduleUpdate() {
      if (rafId !== null) return;

      rafId = requestAnimationFrame(() => {
        rafId = null;
        observeFooterElements();
        updateFloatingButtonsOffset();
      });
    }

    scheduleUpdate();

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('load', scheduleUpdate, { once: true });

    document.addEventListener('shopify:section:load', scheduleUpdate);
    document.addEventListener('shopify:section:reorder', scheduleUpdate);
    document.addEventListener('shopify:section:unload', scheduleUpdate);

    if ('MutationObserver' in window) {
      const mutationObserver = new MutationObserver(scheduleUpdate);
      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-archive"]) return;
  try {
    
  document.documentElement.classList.add('archive-tabs-initialized');

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function releaseInitialArchiveVisibilityLock() {
    const lock = document.getElementById('archive-initial-visibility');
    if (!lock) return;

    requestAnimationFrame(() => {
      lock.remove();
    });
  }

  function forceArchiveLandingAtTop() {
    const root = document.documentElement;
    const body = document.body;

    root.scrollTop = 0;
    if (body) {
      body.scrollTop = 0;
    }

    window.scrollTo(0, 0);
  }

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      forceArchiveLandingAtTop();
    },
    { once: true },
  );

  window.addEventListener(
    'pageshow',
    () => {
      forceArchiveLandingAtTop();
    },
    { once: true },
  );

  function showSection(section) {
    section.style.removeProperty('display');
    section.hidden = false;
    section.removeAttribute('inert');
    section.setAttribute('aria-hidden', 'false');
    section.classList.add('archive-section--active');
  }

  function hideSection(section) {
    section.style.setProperty('display', 'none');
    section.hidden = true;
    section.setAttribute('inert', '');
    section.setAttribute('aria-hidden', 'true');
    section.classList.remove('archive-section--active');
  }

  function isSectionActive(section) {
    if (!(section instanceof HTMLElement)) return false;

    return (
      section.hidden === false &&
      section.getAttribute('aria-hidden') !== 'true' &&
      section.classList.contains('archive-section--active') &&
      section.style.display !== 'none'
    );
  }

  function getActiveArchiveSectionId() {
    const activeSection = Array.from(document.querySelectorAll('[data-archive-section-id]')).find((section) => {
      return isSectionActive(section);
    });

    return activeSection?.dataset.archiveSectionId || null;
  }

  function scrollArchivePageToTop() {
    const root = document.documentElement;
    const body = document.body;
    const previousRootScrollBehavior = root.style.getPropertyValue('scroll-behavior');
    const previousRootScrollBehaviorPriority = root.style.getPropertyPriority('scroll-behavior');
    const previousBodyScrollBehavior = body ? body.style.getPropertyValue('scroll-behavior') : '';
    const previousBodyScrollBehaviorPriority = body ? body.style.getPropertyPriority('scroll-behavior') : '';

    root.style.setProperty('scroll-behavior', 'auto', 'important');
    if (body) {
      body.style.setProperty('scroll-behavior', 'auto', 'important');
    }

    root.scrollTop = 0;
    if (body) {
      body.scrollTop = 0;
    }
    window.scrollTo(0, 0);

    requestAnimationFrame(() => {
      if (previousRootScrollBehavior) {
        root.style.setProperty('scroll-behavior', previousRootScrollBehavior, previousRootScrollBehaviorPriority);
      } else {
        root.style.removeProperty('scroll-behavior');
      }

      if (!body) return;

      if (previousBodyScrollBehavior) {
        body.style.setProperty('scroll-behavior', previousBodyScrollBehavior, previousBodyScrollBehaviorPriority);
      } else {
        body.style.removeProperty('scroll-behavior');
      }
    });
  }

  function syncArchiveSectionVisibility(targetId, targetSection, force = false) {
    const allSections = document.querySelectorAll('[data-archive-section-id]');
    const shouldMutate = force
      ? true
      : Array.from(allSections).some((section) => {
          const shouldBeActive = section === targetSection || section.dataset.archiveSectionId === targetId;
          const currentlyActive = isSectionActive(section);

          return shouldBeActive ? currentlyActive === false : currentlyActive === true;
        });

    if (!shouldMutate) return;

    allSections.forEach((section) => {
      if (section === targetSection || section.dataset.archiveSectionId === targetId) {
        showSection(section);
      } else {
        hideSection(section);
      }
    });
  }

  function setActiveArchiveButton(activeButton) {
    const allButtons = document.querySelectorAll('[data-target-section-id]');
    allButtons.forEach((button) => {
      const isActive = button === activeButton;
      button.classList.toggle('archive-button--active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function syncArchiveURL(targetId) {
    const nextURL = new URL(window.location.href);
    nextURL.searchParams.set('archive_view', targetId);

    ['page', 'collections_page', 'archive_page', 'products_page', 'archive_products_sync', 'archive_collections_sync'].forEach(
      (param) => {
        nextURL.searchParams.delete(param);
      },
    );

    if (nextURL.toString() === window.location.href) return;

    history.replaceState('', '', nextURL.toString());
  }

  function ensureArchiveModuleScript(moduleSrc) {
    if (!moduleSrc) return Promise.resolve();

    const existingScript = Array.from(document.querySelectorAll('script[type="module"][src]')).find((script) => {
      return script.getAttribute('src') === moduleSrc;
    });

    if (existingScript) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const moduleScript = document.createElement('script');
      moduleScript.type = 'module';
      moduleScript.src = moduleSrc;
      moduleScript.fetchPriority = 'low';
      moduleScript.addEventListener('load', () => resolve(), { once: true });
      moduleScript.addEventListener('error', () => reject(new Error('Could not load module script')), { once: true });
      document.head.append(moduleScript);
    });
  }

  const pendingArchiveSectionHydrations = new Map();

  async function hydrateArchiveSection(section) {
    if (!section || !section.dataset.deferredSectionId) return section;

    const deferredSectionId = section.dataset.deferredSectionId;
    const pendingHydration = pendingArchiveSectionHydrations.get(deferredSectionId);
    if (pendingHydration) {
      return pendingHydration;
    }

    const hydrationPromise = (async () => {
      section.dataset.deferredSectionLoading = 'true';

      try {
        await ensureArchiveModuleScript(section.dataset.deferredModuleSrc);

        const sectionUrl = new URL(window.location.href);
        sectionUrl.searchParams.set('section_id', deferredSectionId);
        sectionUrl.hash = '';

        const response = await fetch(sectionUrl.toString(), {
          credentials: 'same-origin',
        });

        if (!response.ok) return section;

        const html = await response.text();
        const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        const nextSectionRoot = parsedDocument.getElementById(`shopify-section-${deferredSectionId}`);
        const currentSectionRoot = section.closest('.shopify-section');

        if (!nextSectionRoot || !currentSectionRoot) return section;

        currentSectionRoot.replaceWith(nextSectionRoot);

        const sectionSelector = `[data-archive-section-id="${CSS.escape(section.dataset.archiveSectionId)}"]`;
        return nextSectionRoot.querySelector(sectionSelector) || nextSectionRoot;
      } catch {
        section.dataset.deferredSectionLoading = 'false';
        return section;
      }
    })();

    pendingArchiveSectionHydrations.set(deferredSectionId, hydrationPromise);

    try {
      return await hydrationPromise;
    } finally {
      pendingArchiveSectionHydrations.delete(deferredSectionId);
    }
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-target-section-id]');
    if (!button) return;

    const targetId = button.dataset.targetSectionId;
    if (!targetId) return;

    const previousActiveSectionId = getActiveArchiveSectionId();

    setActiveArchiveButton(button);

    const targetSelector = `[data-archive-section-id="${CSS.escape(targetId)}"]`;
    let targetSection = document.querySelector(targetSelector);
    if (targetSection?.dataset.deferredSectionId) {
      targetSection = await hydrateArchiveSection(targetSection);
    }

    syncArchiveSectionVisibility(targetId, targetSection, true);

    syncArchiveURL(targetId);

    if (previousActiveSectionId && previousActiveSectionId !== targetId) {
      scrollArchivePageToTop();
    }
  });

  // Activate section based on URL state, falling back to the first archive button.
  document.addEventListener(
    'DOMContentLoaded',
    async () => {
      const requestedTargetId = new URL(window.location.href).searchParams.get('archive_view');

      const effectiveTargetId =
        requestedTargetId === 'archived-products' || requestedTargetId === 'archived-collections'
          ? requestedTargetId
          : 'archived-collections';

      const nextURL = new URL(window.location.href);
      let shouldReplaceURL = false;

      if (requestedTargetId !== effectiveTargetId) {
        nextURL.searchParams.set('archive_view', effectiveTargetId);
        shouldReplaceURL = true;
      }

      ['page', 'collections_page', 'archive_page', 'products_page', 'archive_products_sync', 'archive_collections_sync'].forEach(
        (param) => {
          if (!nextURL.searchParams.has(param)) return;
          nextURL.searchParams.delete(param);
          shouldReplaceURL = true;
        },
      );

      if (shouldReplaceURL) {
        history.replaceState('', '', nextURL.toString());
      }

      let initialButton = document.querySelector(`[data-target-section-id="${CSS.escape(effectiveTargetId)}"]`);
      if (!initialButton) {
        initialButton = document.querySelector('[data-target-section-id]');
      }

      if (!initialButton) {
        releaseInitialArchiveVisibilityLock();
        return;
      }

      const targetId = initialButton.dataset.targetSectionId;
      if (!targetId) {
        releaseInitialArchiveVisibilityLock();
        return;
      }

      const targetSelector = `[data-archive-section-id="${CSS.escape(targetId)}"]`;
      let target = document.querySelector(targetSelector);
      if (target?.dataset.deferredSectionId) {
        target = await hydrateArchiveSection(target);
      }

      if (target) {
        setActiveArchiveButton(initialButton);
        syncArchiveSectionVisibility(targetId, target);
        syncArchiveURL(targetId);
      }

      releaseInitialArchiveVisibilityLock();
      },
      { once: true },
    );
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
